export function evaluateCondition(condition, selfValue, allValues) {
  if (!condition) return false;
  if (condition.always) return true;
  if (Array.isArray(condition.all)) {
    return condition.all.every(c => evaluateCondition(c, selfValue, allValues));
  }
  if (Array.isArray(condition.any)) {
    return condition.any.some(c => evaluateCondition(c, selfValue, allValues));
  }

  const fieldValue = condition.field === 'self'
    ? selfValue
    : allValues[condition.field] ?? '';

  switch (condition.op) {
    case 'eq':
      return String(fieldValue) === String(condition.value);

    case 'neq':
      return String(fieldValue) !== String(condition.value);

    case 'in':
      return Array.isArray(condition.value) && condition.value.includes(fieldValue);

    case 'notIn':
      return Array.isArray(condition.value) && !condition.value.includes(fieldValue);

    case 'isEmpty':
      return !fieldValue || fieldValue === '' || fieldValue === '-1';

    case 'isNotEmpty':
      return !!fieldValue && fieldValue !== '' && fieldValue !== '-1';

    case 'gt':
      return Number(fieldValue) > Number(condition.value);

    case 'gte':
      return Number(fieldValue) >= Number(condition.value);

    case 'lt':
      return Number(fieldValue) < Number(condition.value);

    case 'lte':
      return Number(fieldValue) <= Number(condition.value);

    default:
      console.warn(`[FieldEngine] Unknown condition operator: "${condition.op}"`);
      return false;
  }
}
